import React from 'react';
import { Link } from 'react-router-dom';

import { Box, MenuItem, Typography } from '@mui/material';

type MenuItemWithIconProps = {
  icon: React.ReactNode;
  text: string;
  onClick: () => void;
  to: string;
};

const MenuItemIcon = ({ icon, text, to, onClick }: MenuItemWithIconProps) => (
  <>
    <Link to={to}>
      <MenuItem onClick={onClick} sx={{ px: 3, py: 1.5, display: 'flex', alignItems: 'center' }}>
        <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>{icon}</Box>
        <Typography>{text}</Typography>
      </MenuItem>
    </Link>
  </>
);

export default MenuItemIcon;
